import React from 'react'

const Navbar = () => {
    return (
        <div>
            <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                <a className="navbar-brand ps-3" href="index.html">Zyanwoa Service Monitor</a>
            </nav>
        </div>

    )
}

export default Navbar